import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Paragraph, List, Anchor, Flex, Divider } from "@zillow/constellation";
import { yieldCallback } from "@zillow/yield-callback";
import React from "react";
import { GROUP_WIDTH_MAP } from "../../mixins/components/GroupMixin.esm.js";
import { getCmsInfoForPage } from "../../utils/clickstream/getCmsInfoForPage.esm.js";
import { usePageProps } from "../PagePropsProvider/PagePropsProvider.esm.js";
import { sendEvent } from "./B2BMainNav.utils.esm.js";
const ColumnsNav = ({
  columns,
  transparent,
  isVisible,
  onMouseEnter,
  onMouseLeave
}) => {
  const pageProps = usePageProps();
  const cmsInfo = getCmsInfoForPage(pageProps);
  const handleLinkClick = (label, url) => {
    sendEvent("cms_link", label, url, cmsInfo);
  };
  if (!columns || columns.length === 0) {
    return null;
  }
  const limitedColumns = columns.slice(0, 4);
  return /* @__PURE__ */ jsx(Box, { "data-testid": "columns-nav", onMouseEnter, onMouseLeave, sx: {
    display: isVisible ? "block" : "none",
    fontSize: "$fontSizes.body",
    fontWeight: "$fontWeights.body",
    paddingInlineStart: "0",
    "@media $xl": {
      backgroundColor: "$colors.backgroundWhite",
      border: "$borderWidths.xs solid $colors.borderLight",
      boxShadow: "$shadows.lg",
      position: "absolute",
      top: "100%",
      left: 0,
      right: 0,
      width: "100%",
      zIndex: 1e3
    },
    "@media $lg_lte": {
      backgroundColor: "$colors.backgroundLight",
      borderTop: "solid 1px $colors.borderLight",
      padding: "$spacing.xs 0",
      position: "relative",
      width: "100%"
    }
  }, children: /* @__PURE__ */ jsx(Box, { sx: {
    display: "flex",
    maxWidth: GROUP_WIDTH_MAP.xl,
    margin: "0 auto",
    padding: "$spacing.md",
    gap: "$spacing.lg",
    "@media $lg_lte": {
      flexDirection: "column",
      gap: "$spacing.md",
      padding: 0,
      alignItems: "stretch"
    }
  }, children: limitedColumns.map((column, index) => {
    const isFirstColumn = index === 0;
    const isLastColumn = index === limitedColumns.length - 1;
    return /* @__PURE__ */ jsxs(React.Fragment, { children: [
      /* @__PURE__ */ jsxs(Box, { sx: {
        width: "25%",
        flexDirection: "column",
        display: "flex",
        gap: "$spacing.sm",
        padding: "$spacing.xs $spacing.sm",
        "@media $lg_lte": {
          width: "100%",
          paddingLeft: "$spacing.sm",
          paddingRight: "$spacing.sm",
          paddingTop: isFirstColumn ? "$spacing.sm" : 0,
          paddingBottom: isLastColumn ? "$spacing.sm" : 0
        }
      }, children: [
        column.heading && /* @__PURE__ */ jsx(Box, { as: "h3", sx: {
          color: transparent ? "$colors.textWhite" : "$colors.textDark",
          fontSize: "$fontSizes.body",
          fontWeight: "$fontWeights.bold",
          margin: 0
        }, children: column.heading }),
        column.description && /* @__PURE__ */ jsx(Paragraph, { sx: {
          color: transparent ? "$colors.textWhite" : "$colors.textMedium",
          fontSize: "$fontSizes.bodySmall"
        }, children: column.description }),
        column.links && column.links.length > 0 && /* @__PURE__ */ jsx(List, { appearance: "none", sx: {
          display: "flex",
          flexDirection: "column",
          gap: "$spacing.xs",
          margin: 0,
          padding: 0
        }, children: column.links.map((link, linkIndex) => /* @__PURE__ */ jsx(List.Item, { children: /* @__PURE__ */ jsx(Box, { as: Anchor, href: link.url, target: link.target, rel: link.target === "_blank" ? "noopener noreferrer" : void 0, sx: {
          "&&&&": {
            textDecoration: "none",
            fontSize: "$fontSizes.bodySmall",
            fontWeight: "$fontWeights.bodySmall"
          },
          "&&&&:hover": {
            textDecoration: "underline"
          },
          "@media $lg_lte": {
            display: "block",
            width: "100%",
            textAlign: "left",
            padding: 0
          }
        }, onClick: yieldCallback(() => {
          handleLinkClick(link.title, link.url);
        }), children: link.title }) }, `${link.title}-${linkIndex}`)) })
      ] }),
      index < limitedColumns.length - 1 && /* @__PURE__ */ jsxs(Flex, { sx: {
        alignItems: "stretch"
      }, children: [
        /* @__PURE__ */ jsx(Divider, { sx: {
          "@media $lg_lte": {
            display: "none"
          }
        } }),
        /* @__PURE__ */ jsx(Divider, { orientation: "vertical", length: "fluid", sx: {
          display: "none",
          "@media $lg_lte": {
            display: "block",
            alignSelf: "stretch",
            width: "1px",
            margin: "$spacing.xs 0"
          }
        } })
      ] })
    ] }, index);
  }) }) });
};
export {
  ColumnsNav as default
};
